module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av560-9aa19a1da05013a85bde6bf68c1354a5.jpg";